import React from 'react';

/**
 * Sticky, app-wide banner shown ONLY while an admin is impersonating a restaurant
 * (i.e. an admin opened a restaurant's own panel via "Open Panel"). It reads the
 * stashed admin session from localStorage; "Exit to Admin" restores that session
 * and returns to the admin panel. Renders nothing for everyone else.
 */
export default function ImpersonationBanner() {
  const returnToken = localStorage.getItem('impersonation_return_token');
  if (!returnToken) return null;

  let info = {};
  try { info = JSON.parse(localStorage.getItem('impersonation_active') || '{}'); } catch (_) { info = {}; }

  const exitToAdmin = () => {
    const refresh = localStorage.getItem('impersonation_return_refresh') || '';
    // Restore the admin session.
    localStorage.setItem('token', returnToken);
    if (refresh) localStorage.setItem('refreshToken', refresh);
    else localStorage.removeItem('refreshToken');
    // Clear impersonation state + the stale restaurant user cache.
    localStorage.removeItem('impersonation_return_token');
    localStorage.removeItem('impersonation_return_refresh');
    localStorage.removeItem('impersonation_active');
    localStorage.removeItem('user');
    // Hard reload → AuthContext re-inits cleanly back as the admin.
    window.location.href = '/admin/dashboard';
  };

  return (
    <div style={styles.bar}>
      <span>🔒 Admin view — acting as <strong>{info.restaurantName || 'restaurant'}</strong></span>
      <button onClick={exitToAdmin} style={styles.btn}>Exit to Admin</button>
    </div>
  );
}

const styles = {
  bar: {
    position: 'sticky',
    top: 0,
    zIndex: 100000,
    background: '#7c3aed',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 500,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  btn: {
    background: '#fff',
    color: '#7c3aed',
    border: 'none',
    borderRadius: '6px',
    padding: '6px 14px',
    fontWeight: 700,
    cursor: 'pointer',
    fontSize: '13px',
  },
};
